export function buildAuthorshipUserType(): string {
  return `import type { AdminUserSummary } from '@admin/types'`
}
